(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    // Prevent duplicate listeners if the section renders multiple times
    if (window.__ingredientsDrawerBound) return;
    window.__ingredientsDrawerBound = true;

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-ingredients-open]');
      var closeBtn = e.target.closest('[data-ingredients-close]');
      var backdrop = e.target.closest('[data-ingredients-backdrop]');

      if (!openBtn && !closeBtn && !backdrop) return;

      var drawer = document.querySelector('[data-ingredients-drawer]');
      var bd = document.querySelector('[data-ingredients-backdrop]');
      if (!drawer || !bd) return;

      function open() {
        drawer.hidden = false;
        bd.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }

      function close() {
        drawer.hidden = true;
        bd.hidden = true;
        document.documentElement.style.overflow = '';
      }

      if (openBtn) open();
      if (closeBtn || backdrop) close();
    });
  })();

  // Usage Method Drawer
  (function () {
    if (window.__usageDrawerBound) return;
    window.__usageDrawerBound = true;

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-usage-open]');
      var closeBtn = e.target.closest('[data-usage-close]');
      var backdrop = e.target.closest('[data-usage-backdrop]');

      if (!openBtn && !closeBtn && !backdrop) return;

      var drawer = document.querySelector('[data-usage-drawer]');
      var bd = document.querySelector('[data-usage-backdrop]');
      if (!drawer || !bd) return;

      function open() {
        drawer.hidden = false;
        bd.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }

      function close() {
        drawer.hidden = true;
        bd.hidden = true;
        document.documentElement.style.overflow = '';
      }

      if (openBtn) open();
      if (closeBtn || backdrop) close();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
